import { useIntl } from "react-intl";

import StatusSuccessIcon from "@atlaskit/icon/core/status-success";
import { Flex, xcss } from "@atlaskit/primitives";

import messages from "./messages";

export const ShareLinkCopyButtonPopup = () => {
    const { formatMessage } = useIntl();

    return (
        <Flex
            xcss={popupStyles}
            gap="space.100"
            alignItems="center"
            justifyContent="space-between"
        >
            <StatusSuccessIcon label="success" color="var(--ds-icon-success)" />
            {formatMessage(messages.linkShareCopiedPopup)}
        </Flex>
    );
};

const popupStyles = xcss({
    paddingInline: "space.200",
    paddingBlock: "space.100"
});
